module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"frontmatter":{"username":"Karim-Adnan","fullname":"Adnan Karim"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/submissions.json
// module id = 329
// module chunks = 236347314162643